import React from 'react';
import { CircularProgress, Backdrop } from '@material-ui/core';

//css
import Styles from './styles';
const useStyles = Styles();

export default (props) => {
    const classes = useStyles();
    return (
        <>
            {props.state.isLoading &&
                <Backdrop 
                    className={classes.backdrop}
                    open={props.state.isLoading}
                >
                    <CircularProgress style={{color:"#fff"}}/>
                </Backdrop>
            }
        </>
    );
};